import { type Enum } from '@webapp/infrastructure/types/Enum'

// TransactionReconciliationPage
export const TransactionReconciliationPageTabStatuses = {
  NEEDS_REVIEW: 'needs-review',
  REVIEWED: 'reviewed',
} as const
export type TransactionReconciliationPageTabStatus = Enum<
  typeof TransactionReconciliationPageTabStatuses
>

export interface TransactionReconciliationPageParams {
  tab: TransactionReconciliationPageTabStatus
}

// CardManagementPage
export const CardManagementPageTabStatuses = {
  ACTIVE: 'active',
  PENDING: 'pending',
  LOCKED: 'locked',
  BLOCKED: 'blocked',
  CANCELED: 'canceled',
} as const

export type CardManagementPageTabStatusEnum = Enum<
  typeof CardManagementPageTabStatuses
>

export interface CardManagementPageParams {
  status: CardManagementPageTabStatusEnum
}

export interface CardManagementDetailsPageParams {
  id: string
  fundStatus: 'open' | 'closed'
}

export interface CardManagementFundDetailsPageParams {
  id: string
  fundId: string
}
